// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"143":"app","736":"vendor"}[chunkId] || chunkId) + "." + {"143":"1e2ef380","736":"80c2c996","969":"d7903cac"}[chunkId] + ".css";
};